import { path, pathOr } from 'ramda';

export const getProfileInfo = state => path(['profile', 'info', 'info'], state);

export const isProfileFetching = state => pathOr({}, ['profile', 'info', 'fetching'], state);

export const getServicesList = state => pathOr([], ['profile', 'services', 'services'], state);

export const getAccess = state => pathOr(false, ['profile', 'info', 'info', 'access'], state);
